module.exports = __webpack_public_path__ + "img/devil.338721dd.gif";